import { ThemeType, CssType } from '../../theme/jss-types';

const NavbarStyles = (theme: ThemeType) : CssType => ({
  navbar: {
    height: '64px',
    flexShrink: 0,
    padding: '4px 16px',
    borderBottom: '1px solid #D9D9D9',
    color: '#424242',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    color: '#424242',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '22px',
    marginLeft: '8px',
  },
  menuButton: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default NavbarStyles;
